import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { number, string, array } from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Card from '../Card/Card';
import DateTime from '../DateTime/DateTime';
import { createMarkup } from '../../utils/utils';
import { STATIC_PATH } from '../../config';

class NewsItem extends PureComponent {
  static propTypes = {
    title: string.isRequired,
    text: string.isRequired,
    its: number.isRequired,
    offers: array.isRequired,
  };

  static defaultProps = {
    its: 0,
    offers: [],
  };

  getImageURL = (offerId) => {
    const { offerSettings } = this.props;

    if (Object.keys(offerSettings).length) {
      return `${offerSettings['images_path']}${offerId}_r_100x100.png`;
    }
  };

  renderNewsImg = (offers = []) => {
    if (offers.length === 1) {
      return (
        <div className="img-wrapper">
          <LazyLoadImage
            src={this.getImageURL(offers[0].id)}
            className="img-fluid rounded-circle"
            alt=""
          />
        </div>
      );
    }

    return (
      <div className="img-wrapper">
        <img src={`${STATIC_PATH}/img/logo-b.svg`} alt="OFFERRUM" className="img-fluid" />
      </div>
    );
  };

  render() {
    const { title, text, its, offers } = this.props;
    return (
      <Card.Body className="no-padding">
        <div className="news">
          <div className="news-info">
            <div className="news-title-wrapper">
              <h3 className="news-title">{title}</h3>
              <DateTime className="news-date" timestamp={its} />
            </div>
            {this.renderNewsImg(offers)}
          </div>

          <div className="news-text" dangerouslySetInnerHTML={createMarkup(text)} />
        </div>

        {offers.length > 0 && (
          <ul className="news-offers-list list-inline">
            {offers.map(({ id, title }) => (
              <li key={id} className="list-inline-item">
                <Link to={`/offers/${id}`}>{title}</Link>
              </li>
            ))}
          </ul>
        )}
      </Card.Body>
    );
  }
}

export default NewsItem;
